import React from 'react';
import { Link } from 'react-router-dom';
import '../Services.css'; // Using the main Services.css for consistency

const Webinar: React.FC = () => {
  return (
    <div className="services-page">
      <div className="container">
        <div className="page-title">
          <h1>Webinar Training</h1>
          <p>Live interactive sessions with professional traders</p>
        </div>
        
        <div className="service-info">
          <h2>Join Our Live Trading Webinars</h2>
          <p>Our live webinar sessions provide an interactive learning environment where you can engage directly with professional traders. These sessions cover a range of topics from basic trading concepts to advanced strategies.</p>
          
          <div className="service-features">
            <div className="feature">
              <h3>Expert Instructors</h3>
              <p>Learn from experienced traders with proven track records in the markets.</p>
            </div>
            <div className="feature">
              <h3>Interactive Q&A</h3>
              <p>Ask questions and get real-time answers during the sessions.</p>
            </div>
            <div className="feature">
              <h3>Recorded Sessions</h3>
              <p>Can't make it to a live session? Access our library of recorded webinars.</p>
            </div>
          </div>
        </div>
        
        <div className="webinar-schedule">
          <h2>Upcoming Webinars</h2>
          <div className="webinar-list">
            <div className="webinar-item">
              <h3>Introduction to Forex Trading</h3>
              <p className="webinar-date">October 30, 2025 | 15:00 GMT</p>
              <p>Learn the fundamentals of forex trading, currency pairs, and basic analysis techniques.</p>
              <Link to="#" className="btn">Register Now</Link>
            </div>
            <div className="webinar-item">
              <h3>Advanced Technical Analysis</h3>
              <p className="webinar-date">November 5, 2025 | 19:00 GMT</p>
              <p>Deep dive into chart patterns, indicators, and advanced trading strategies.</p>
              <Link to="#" className="btn">Register Now</Link>
            </div>
            <div className="webinar-item">
              <h3>Trading Psychology & Risk Management</h3>
              <p className="webinar-date">November 12, 2025 | 17:00 GMT</p>
              <p>Master the psychological aspects of trading and effective risk management.</p>
              <Link to="#" className="btn">Register Now</Link>
            </div>
          </div>
        </div>
        
        <div className="cta-section">
          <h2>Ready to Improve Your Trading Skills?</h2>
          <p>Join our upcoming webinars and learn from industry professionals.</p>
          <Link to="/services" className="btn primary">Back to Services</Link>
        </div>
      </div>
    </div>
  );
};

export default Webinar;